(function () {
    'use strict';

    angular.module("imApp").factory("equipmentListService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 2045,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
